// It supports deep nested fields and arrays of fields
export default function getModifiedFields(fields) {
  const modified = {};

  for (const key in fields) {
    if (Object.prototype.hasOwnProperty.call(fields, key)) {
      const field = fields[key];

      if (Array.isArray(field)) {
        const modifiedArray = field.map((item) => {
          const result = getModifiedFields(item);
          return Object.keys(result).length > 0 ? result : null;
        }).filter(Boolean);

        if (modifiedArray.length > 0) {
          modified[key] = modifiedArray;
        }
      } else if (typeof field === 'object' && field !== null) {
        if ('dirty' in field && field.dirty) {
          modified[key] = field.value;
        } else {
          const nested = getModifiedFields(field);
          if (Object.keys(nested).length > 0) {
            modified[key] = nested;
          }
        }
      }
    }
  }

  return modified;
}
